// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1ecB3","footer":"ChangeClinic_footer__2T8lB"};